import { render, staticRenderFns } from "./ColumnSetting.vue?vue&type=template&id=4609075b&"
import script from "./ColumnSetting.vue?vue&type=script&lang=js&"
export * from "./ColumnSetting.vue?vue&type=script&lang=js&"
import style0 from "./ColumnSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports